export function generateDailySchedule(details) {
  const { booking_at, start_usage, finish_usage, weeklyMeetingDeadline } = details;

  const schedule = [];
  let currentDate = new Date(booking_at);
  const endDate = weeklyMeetingDeadline ? new Date(weeklyMeetingDeadline) : new Date(booking_at);

  while (currentDate <= endDate) {
    const formattedDate = currentDate.toISOString().split("T")[0];

    const formattedStartUsage = `${formattedDate} ${start_usage}:00`;
    const formattedFinishUsage = `${formattedDate} ${finish_usage}:00`;

    schedule.push({
      start_usage: formattedStartUsage,
      finish_usage: formattedFinishUsage,
    });

    currentDate.setDate(currentDate.getDate() + 1);
  }

  return schedule;
}

export const isAroundTenMinutes = ({ start_usage = new Date() }) => {
  const startUsageTime = new Date(start_usage);

  const currentTime = new Date();

  const isOver = currentTime > startUsageTime;
  let timeDifference = startUsageTime - currentTime;
  if (isOver) {
    timeDifference = currentTime - startUsageTime;
  }
  const tenMinutes = 10 * 60 * 1000;
  return timeDifference < tenMinutes && timeDifference > 0;
};
